// BATTLE-25: Capybara-Arena-Optik — Rasen-Untergrund + Stein-Hex-Tiles als Bild-Layer.
// Assets lokal aus dem Spike-Mirror gespiegelt (public/arena/), CDN wird NIE referenziert.
// Loader-Pattern wie spriteSheets.ts; solange Bilder fehlen, zeichnet der Renderer den
// bisherigen prozeduralen Boden (alles-oder-nichts, kein Misch-Frame).

const BG_URL = '/arena/arena_bg.png'
const TILE_URL = '/arena/hex_tile.png'

// Das generierte Tile ist ein FLAT-TOP-Hex — unser Grid ist pointy-top. Deshalb wird das
// Bild NICHT als Sprite gezeichnet, sondern nur als Stein-TEXTUR benutzt: eine sichere
// Region innerhalb der Deckfläche (ohne Außenkanten/Extrusion), die der Renderer auf die
// eigene Hex-Geometrie clippt. Koordinaten in Referenz-Pixeln des 1536x1024-Quellbilds,
// beim Zeichnen proportional auf naturalWidth/Height skaliert (Learning aus BATTLE-24).
export const TILE_REF = { w: 1536, h: 1024 } as const
// Textur-Fenster: x-Bereich [252..1279] und y-Bereich [189..~740] sind Deckfläche;
// texH ist fix, texW ergibt sich im Renderer aus dem Hex-Seitenverhältnis. jitterX/Y
// = maximaler deterministischer Versatz pro Hex gegen sichtbare Wiederholung.
export const TILE_TEX = { x: 480, y: 290, h: 330, jitterX: 80, jitterY: 30 } as const

// Anteil der Bildhöhe, den die Kulisse (Kolosseum-Mauer/Tribüne) oben einnimmt — darunter
// beginnt der Sandboden. Der Renderer platziert das Bild so, dass diese Linie IMMER über
// der hintersten Tile-Reihe liegt (PO-Befund: Tiles ragten in die Mauer).
export const BG_FLOOR_TOP_FRAC = 0.21

const imgCache = new Map<string, HTMLImageElement>()
const readyCbs: Array<() => void> = []

function getImg(url: string): HTMLImageElement | null {
  if (typeof Image === 'undefined') return null // Node/Tests: kein DOM
  let im = imgCache.get(url)
  if (!im) {
    im = new Image()
    im.onload = () => {
      for (const cb of readyCbs) cb()
    }
    im.src = url
    imgCache.set(url, im)
  }
  return im
}

function loadedImg(url: string): HTMLImageElement | null {
  const im = getImg(url)
  return im && im.complete && im.naturalWidth > 0 ? im : null
}

export function arenaBgImg(): HTMLImageElement | null {
  return loadedImg(BG_URL)
}

export function tileImg(): HTMLImageElement | null {
  return loadedImg(TILE_URL)
}

/** Fire-and-forget-Preload; onReady feuert nach jedem fertigen Bild (Grid-Cache invalidieren). */
export function preloadArena(onReady?: () => void): void {
  if (onReady) readyCbs.push(onReady)
  getImg(BG_URL)
  getImg(TILE_URL)
}
